import { Modules } from "@lib/titan2/dist/game/Constants";
import { HorizontalLayout } from "@lib/titan2/dist/game/control/layout/HorizontalLayout";
import { PanelProperties } from "@lib/titan2/dist/game/control/properties/PanelProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { FeatureReelProperties } from "./FeatureReelProperties";
import { Point } from "pixi.js";
export class FeatureReelsProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.background = new SpriteProperties("BonusReelBackground", Modules.GAME, new Point(-60, -5));
        this.foreground = new SpriteProperties("BonusReelForeground", Modules.GAME, new Point(-60, -5));
        this.panelProperties = new PanelProperties();
        this.panelProperties.position.set(44, 66);
        this.panelProperties.layout = new HorizontalLayout(7);
        this.reelProperties = new FeatureReelProperties();
    }
    ;
    equals(other) {
        return true;
    }
}
//# sourceMappingURL=FeatureReelsProperties.js.map